<template>
    <div id="subContents" class="intro wrap_1120">
        <section id="introCon" class="intro-page" style="display: flex; justify-content: center; align-items: center;">
            <article class="intro-con">
                <img src="img/platform.png" style="max-width: 100%; "></img>
            </article>
        </section>
    </div>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        userStore,
        PageBtn,
        ModalDefault,
        onBeforeMount,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,
            });

            onBeforeMount(() => {});

            onMounted(() => {});

            return { state, router, CommonUtils };
        },
    };
</script>
<style scoped>
    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
    .elips_1 .block {
        width: 100%;
        display: inline-block;
    }
</style>

<style scoped>
    /* ****************** 소개 ****************** */
    /* ---------- 다시함께는? ---------- */
    .intro-page {
        /* margin-top: 27px;  */
    }
    /* 다시함께는? */
</style>
